import {
  dcActionFlag,
  dcAttributeType,
  dcSecurityRights,
  OverrideType,
  ValueType
} from '@nibras/core/common';
import { dcAttribute } from './dcattribute.model';
import { dcAttributeTemplate } from './dcAttributeTemplate.model';
import { dcElementTemplateHeader } from './dcElementTemplateHeader.model';
import { dcHierarchy } from './dcHierarchyTVP';
import { dcTag } from './dcTag.model';
import { GenericValue } from './generic-value.model';

export interface IdcObjectData {
  Header: IdcObjectHeader;
}

export interface DropDownListItem {
  id: string;
  name: string;
}

export interface IdcParentIDHeader {
  ParentElementID: number;
  ParentElementName: string;
}

export interface IdcObjectHeader {
  UniqueID: string;
  Name: string;
}

export interface IdcSecurityHeader {
  Security: dcSecurityRights;
}

export interface IModelChanged {
  isDirty: boolean;
}

export interface IdcValue {
  ValueTypeID: ValueType;
  ValueInt?: number;
  ValueDouble?: number;
  ValueString?: string;
  ValueBoolean?: boolean;
  ValueGuid?: string;
  ValueTime?: Date;
  Value?: GenericValue;
  TimeStamp?: Date;
  IsGood: boolean;
  MessageString?: string;
  displayValue?: any; //TODO: this need to be changed to GenericValue, but need changes in lot of references. So will be doing in Dev3.0
}

export interface IElementTemplateHeader {
  ElementTemplateID: number;
  ElementTemplateName: string;
  ElementTemplateDescription: string;
  BaseElementTemplateID: number;
  ClassificationID: number;
  ElementTypeID: number;
  IsAbstract: boolean;
  IsSingleton: boolean;
  IsDeleted: boolean;
  CreatedBy: number;
  CreatedOn: Date;
  ActiveOn: Date;
  ActionFlag: number;
}

export interface ActionFlaggable {
  ActionFlag: dcActionFlag;
}

export class BaseAttributeOrTemplateHeader
  extends dcElementTemplateHeader
  implements IAttributeTemplateHeader, IdcValue, ActionFlaggable
{
  ActionFlag: dcActionFlag;
  AttributeID?: number;
  ElementTypeID: number;
  ValueInt?: number;
  ValueDouble?: number;
  ValueString?: string;
  ValueBoolean?: boolean;
  ValueGuid?: string;
  ValueTime?: Date;
  Value?: GenericValue;
  TimeStamp?: Date;
  Message?: string;
  IsGood: boolean;
  ElementTemplateID: number;
  AttributeTemplateID: number;
  ParentAttributeTemplateID: number;
  IsDeleted: boolean;
  QueryOperation?: number;
  AttributeTemplateName: string;
  AttributeTemplateLongName: string;
  AttributeTemplateShortName: string;
  AttributeTemplateDescription: string;
  QueryManagerID?: number;
  DefaultValueID?: number;
  ValueTypeID: number;
  UOMID: number;
  IsSystemAttribute: boolean;
  Precision: number;
  AllowOverride: OverrideType;
  AttributeTypeID: dcAttributeType;
  ParentElementAttributeTemplateMapID: number;
  ElementAttributeTemplateMapID: number;
  PrimitiveValueTypeID: number;
  AttributeTemplatePath: string;
  ElementPath: string;
  RootElementVersionID?: number;
  HasError?: boolean;
  AllowMetadataOverride: boolean;

  //Client side properties.
  substitutedValue?: string;
  isDirty: boolean;
  isSelected: boolean;
  isRequired?: boolean;
  isPiTag?: boolean;
  isDefaultValueChanged: boolean;
  oldValue: GenericValue;
  previousQueryManagerID?: number;
  unit?: string;
}

export interface IAttributeTemplateHeader extends IdcValue {
  ElementTemplateID: number;
  AttributeTemplateID: number;
  ParentAttributeTemplateID: number;
  IsDeleted: boolean;
  AttributeTemplateName: string;
  AttributeTemplateShortName: string;
  AttributeTemplateDescription: string;
  QueryManagerID?: number;
  DefaultValueID?: number;
  ValueTypeID: number;
  UOMID: number;
  IsSystemAttribute: boolean;
  Precision: number;
  AllowOverride: OverrideType;
  AttributeTypeID: dcAttributeType;
  ParentElementAttributeTemplateMapID: number;
  ElementAttributeTemplateMapID: number;
  PrimitiveValueTypeID: number;
  isDirty: boolean;
  AttributeTemplatePath: string;
  ElementTypeID: number;
  ActionFlag: dcActionFlag;
  ElementPath: string;
  AllowMetadataOverride: boolean;
}

export interface ErrorMessage {
  ErrorCode: number;
  ErrorLogID: number;
  Message: string;
  HasContext: boolean;
  ExceptionMessage: string;
  error_description: string;
}

export interface CommonProgressBar {
  show: boolean;
  showBackDrop: boolean;
}

export enum FilterTypes {
  SET = 'set',
  NUMBER = 'number',
  DATE = 'date'
}

export enum FilterOperator {
  AND = 'AND',
  OR = 'OR'
}

export interface TableFilter {
  type: string;
  values: GenericValue[];
  filterType: FilterTypes;
  operator: FilterOperator;
  condition1: TableFilter;
  condition2: TableFilter;
  filter: GenericValue;
  filterTo: GenericValue;
  dateFrom: string;
  dateTo: string;
  field: string;
  value: GenericValue;
}

export interface HierarchyTagWrapper {
  selectedHierarchyTag: dcTag;
  triggerForProfileTag?: boolean;
  hierarchyList?: dcTag[];

  readonly selectedNodeId?: number;
  readonly profileTagList?: dcTag[];
  readonly selectedHierarchy?: dcHierarchy;
}

export interface ParsedProcessStatus {
  cssClass: string;
  text: string;
}

export type ValidationStatus = 'INVALID' | 'VALID';

export type AttributeOrTemplate = dcAttribute | dcAttributeTemplate;

export interface GroupedAttributes {
  name: string;
  id: number;
  isExpanded: boolean;
  attributes: AttributeOrTemplate[];
}
